import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        height: "100vh",
        p: 4,
        textAlign: "center",
      }}
    >
      <Stack spacing={2} sx={{ maxWidth: 480 }}>
        <Typography variant="h2" sx={{ fontWeight: 700, opacity: 0.4 }}>
          404
        </Typography>
        <Typography variant="h5">Page not found</Typography>
        <Typography variant="body2" color="text.secondary">
          The page you&apos;re looking for doesn&apos;t exist or was moved.
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="center" sx={{ pt: 1 }}>
          <Button component={Link} to="/" variant="outlined">
            Landing
          </Button>
          {/* /workspace is auth-guarded — an unauthenticated visitor is bounced
              to sign-in by RequireAuth, so this is safe to show unconditionally. */}
          <Button component={Link} to="/workspace" variant="contained">
            Workspace
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
